// src/help/ — config-driven, offline-first help store (WO-H1). Barrel.
export { HelpProvider, useHelp, useHelpEntry, type CoachmarkFlow } from './HelpProvider';
export { DEFAULT_HELP_BUNDLE } from './content';
export {
  SCREEN_KEYS,
  FLOW_KEYS,
  ROUTE_TO_SCREEN_KEY,
  screenKeyForRoute,
  type ScreenKey,
  type FlowKey,
} from './screenKeys';
